import React, { useContext, useEffect, useRef, useState } from 'react';
import I18n from '@/modules/i18n';
import CorrelationsContext from '@/components/common/Context';
import styles from '../Correlations.module.scss';
import { LessonType, TagType, UnitType } from '../types';
import UnitTagContent from './UnitTagContent';
import LessonTagContent from './LessonTagContent';
import Text from '@/components/ui/Text';

interface TagCardPropType {
  tag: TagType;
  anchored: boolean;
  isSysadmin: boolean;
}

const TagCard = ({ tag, anchored, isSysadmin }: TagCardPropType) => {
  const { programId } = useContext(CorrelationsContext);
  const ref = useRef(null);

  const headerLabel = (model: LessonType | UnitType) => {
    const isComingSoon = 'comingSoon' in model && model.comingSoon;
    const title = isComingSoon ? `${model.title} (${I18n.t('coming_soon')})` : model.title;

    if ('titleNumber' in model && model.titleNumber) {
      return `${I18n.t('unit')} ${model.unitPosition} - ${I18n.t('lesson')} ${model.titleNumber} - ${title}`;
    }

    return `${I18n.t('unit')} ${model.unitPosition} - ${title}`;
  };

  useEffect(() => {
    if (!anchored || !ref.current) return;

    ref.current.scrollIntoView();
  }, [ref.current]);

  return (
    <section
      key={tag.id}
      ref={ref}
      aria-label={`Benchmarks for ${tag.alias}`}
      className={`card ${styles.card}`}
      id={tag.alias}
    >
      <Text className={styles.header} size="sm">
        {I18n.locale === 'es' ? tag.description_es : tag.description_en}
      </Text>

      <>
        <div>
          {tag.units.map(unit => (
            <UnitTagContent
              key={unit.id}
              headerLabel={headerLabel(unit)}
              programId={programId}
              tag={tag}
              unit={unit}
            />
          ))}
        </div>

        <div>
          {tag.lessons.map(lesson => (
            <LessonTagContent
              key={lesson.id}
              headerLabel={headerLabel(lesson)}
              isSysadmin={isSysadmin}
              lesson={lesson}
              programId={programId}
              tag={tag}
            />
          ))}
        </div>
      </>
    </section>
  );
};

export default TagCard;
